export default __webpack_public_path__ + "static/media/help_light_mode.7c83718e.svg";